const PRODUCTION_APP_ORIGIN = 'https://www.aerodestinytravel.com';

function normalizeOrigin(value: string) {
  return value.replace(/\/+$/, '');
}

export function getCanonicalAppOrigin() {
  const configuredOrigin = (import.meta.env.VITE_PUBLIC_APP_URL as string | undefined)?.trim();
  if (configuredOrigin) {
    return normalizeOrigin(configuredOrigin);
  }

  if (typeof window === 'undefined') {
    return PRODUCTION_APP_ORIGIN;
  }

  const currentOrigin = normalizeOrigin(window.location.origin);
  const currentHost = window.location.hostname.toLowerCase();
  const productionHost = new URL(PRODUCTION_APP_ORIGIN).hostname.toLowerCase();

  if (currentHost.endsWith('.vercel.app') && currentHost !== productionHost) {
    return PRODUCTION_APP_ORIGIN;
  }

  return currentOrigin;
}

export function buildAppUrl(path: string) {
  const origin = getCanonicalAppOrigin();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${normalizedPath}`;
}

export function hasSupabaseAuthPayload(url: URL) {
  const hashValue = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash;
  const hashParams = new URLSearchParams(hashValue);

  return Boolean(
    url.searchParams.get('code') ||
      url.searchParams.get('token_hash') ||
      hashParams.get('access_token') ||
      hashParams.get('refresh_token') ||
      hashParams.get('type') ||
      hashParams.get('error_description'),
  );
}

